import { atomWithStorage, createJSONStorage } from 'jotai/utils';

/**
 * Initializes and persists a Jotai atom to session storage.
 */
export function atomWithSessionStorage<T>(key: string, initialValue: T) {
  const storage = createJSONStorage<T>(() => sessionStorage);
  return atomWithStorage<T>(key, initialValue, storage);
}
